// removed by extract-text-webpack-plugin
module.exports = {"container":"_1XatGYX-yZ7ZZwpqWL9Z4k","text":"_3jaP3HXxSIRB46JopZ9KuP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Banner/styles.css
// module id = 326
// module chunks = 0